import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import type { TableActionsButtonProps } from './TableActionsButton';
import { TableActionsInline } from './TableActionsInline';

export function getButtonsEditSaveCancel({
    cancelDisabled,
    onSave,
    onCancel,
}: {
    cancelDisabled?: boolean;
    onSave: () => void;
    onCancel: () => void;
}): TableActionsButtonProps[] {
    return [
        {
            icon: <CheckOutlined />,
            id: 'salvar',
            onClick: onSave,
            type: 'primary',
        },
        {
            danger: true,
            disabled: cancelDisabled,
            icon: <CloseOutlined />,
            id: 'cancelar',
            onClick: onCancel,
            type: 'primary',
        },
    ];
}

export function TableActionsSaveCancel({
    cancelDisabled,
    onSave,
    onCancel,
}: {
    cancelDisabled?: boolean;
    onSave: () => void;
    onCancel: () => void;
}) {
    const buttons = getButtonsEditSaveCancel({ cancelDisabled, onCancel, onSave });

    return <TableActionsInline buttons={buttons} />;
}
